import { User, UserCustomer, CustomerAddress } from 'Types'

export const isCustomer = (user: User | null): user is UserCustomer => !!user && user.isCustomer

export const customerAddressTitle = (customerAddress: CustomerAddress): string =>
  `${customerAddress.address1}, ${customerAddress.city} ${customerAddress.zipCode}, ${customerAddress.country}`
